import Hammer from 'hammer';
import nextArrowSVG from '../../../assets/js/components/_next-arrow-svg';
import prevArrowSVG from '../../../assets/js/components/_prev-arrow-svg';

const getNavButton = function( className = 'media-text-slider__prev', innerHTML = '' ) {
	const button = document.createElement('button');

	button.type = 'button';
	button.className = className;
	button.innerHTML = innerHTML;

	return button;
}

const getPrevButton = function() {
	return getNavButton( 'media-text-slider__prev', `${prevArrowSVG} Prev` );
}

const getNextButton = function() {
	return getNavButton( 'media-text-slider__next', `Next ${nextArrowSVG}` );
}

class MediaTextSlide {
	constructor( node, index, slider ) {
		this.node = node;
		this.index = index;
		this.slider = slider;

		this.wrap = document.createElement('div');
		this.wrap.className = 'media-text-slider__slide';
		this.node.parentNode.appendChild(this.wrap);
		this.wrap.appendChild(this.node);

		this.media   = this.node.querySelector('.wp-block-media-text__media');
		this.content = this.node.querySelector('.wp-block-media-text__content');

		this.nav = document.createElement('nav');
		this.nav.className = 'media-text-slider__nav';

		this.prev = getPrevButton();
		this.prev.addEventListener('click', () => this.slider.goTo( this.index - 1 ) );
		this.nav.appendChild(this.prev);

		this.next = getNextButton();
		this.next.addEventListener('click', () => this.slider.goTo( this.index + 1 ) );
		this.nav.appendChild(this.next);

		this.video = this.media.querySelector('video');

		this.content.appendChild(this.nav);
	}

	blur() {
		this.prev.setAttribute('tabIndex', '-1');
		this.next.setAttribute('tabIndex', '-1');

		if ( this.video ) {
			this.video.pause();
		}
	}

	focus() {
		this.prev.removeAttribute('tabIndex');
		this.next.removeAttribute('tabIndex');

		let focusable = this.content.querySelector( [
			'a[href]',
			'[contenteditable]',
			'input:not([disabled])',
			'select:not([disabled])',
			'button:not([disabled])',
			'textarea:not([disabled])',
			'[tabIndex]:not([tabIndex="-1"])',
		].join(', ') );

		if ( focusable ) {
			focusable.focus();
		}
	}
}

class MediaTextSlider {
	constructor(node, opts) {
		this.node   = node;
		this.index  = -1;
		this.wrap   = this.node.querySelector('.media-text-slider__wrap');

		if ( this.wrap.children.length > 1 ) {
			this.slides = Array.from( this.wrap.children ).map( ( node, index, slides ) => {
				const slide = new MediaTextSlide( node, index, this );

				if ( index === 0 ) {
					slide.prev.disabled = true;
				}

				if ( index === slides.length - 1 ) {
					slide.next.disabled = true;
				}

				return slide;
			} );
		} else {
			this.slides = [];
		}

		this.nav = document.createElement('nav');
		this.nav.className = 'media-text-slider__nav';
		this.node.appendChild(this.nav);

		this.prevBtn = getPrevButton();
		this.prevBtn.addEventListener('click', this.prev.bind(this) );
		this.nav.appendChild(this.prevBtn);

		this.nextBtn = getNextButton();
		this.nextBtn.addEventListener('click', this.next.bind(this) );
		this.nav.appendChild(this.nextBtn);

		this.node.classList.add('media-text-slider--ready');
		this.goTo(0, false);

		this.hammer = new Hammer( this.node );
		this.hammer.on('swipeleft', this.next.bind(this) );
		this.hammer.on('swiperight', this.prev.bind(this) );
	}

	goTo( index, focus = true ) {
		if ( ! this.slides[index] ) {
			return;
		}

		if ( this.index > -1 ) {
			this.slides[this.index].blur();
		}

		this.index = index;
		this.wrap.style.transform = `translateX(-${this.index * 100}%)`;

		if ( this.index === 0 ) {
			this.prevBtn.disabled = true;
			this.nextBtn.removeAttribute('disabled');
		} else if ( this.index === this.slides.length - 1 ) {
			this.prevBtn.removeAttribute('disabled');
			this.nextBtn.disabled = true;
		} else {
			this.prevBtn.removeAttribute('disabled');
			this.nextBtn.removeAttribute('disabled');
		}

		if ( focus ) {
			let transitionend = (e) => {
				if ( e.target === this.wrap && e.propertyName === 'transform' ) {
					this.slides[this.index].focus();
					this.wrap.removeEventListener( 'transitionend', transitionend );
				}
			}

			this.wrap.addEventListener( 'transitionend', transitionend );
		}
	}

	prev() {
		this.goTo( this.index - 1 );
	}

	next() {
		this.goTo( this.index + 1 );
	}
}

MediaTextSlider.instances = Array.from(document.querySelectorAll('.media-text-slider')).map(n => new MediaTextSlider(n));

export default MediaTextSlider;
